import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import { findPost } from '../data/posts';
import { useLanguage } from '../lib/LanguageContext';

const PostDetailPage = () => {
  const { slug } = useParams();
  const { language } = useLanguage();
  const post = findPost(slug);
  const content = post?.[language] || post?.en;

  useEffect(() => {
    if (!content) return undefined;
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute('content');
    document.title = `${content.title} — DIMIRXSON`;
    meta?.setAttribute('content', content.excerpt);
    return () => {
      document.title = previousTitle;
      if (meta && previousDescription !== null) meta.setAttribute('content', previousDescription);
    };
  }, [content]);

  if (!post) return <Navigate to="/journal" replace />;
  const ro = language === 'ro';

  return <div className="min-h-screen bg-bone text-charcoal" data-testid="post-detail-page">
    <Header />
    <main>
      <article>
        <header className="px-6 pb-12 pt-32 md:px-12 md:pb-16 md:pt-40 lg:px-16">
          <Reveal>
            <nav className="text-[10px] uppercase tracking-eyebrow text-charcoal/50 md:text-[11px]">
              <Link to="/journal" className="hover:opacity-60">{ro ? 'News și Jurnal' : 'News & Journal'}</Link>
              <span className="mx-2">/</span><span>{post.type}</span>
            </nav>
            <h1 className="mt-8 max-w-[1500px] font-sans text-5xl font-extrabold leading-[0.92] sm:text-6xl md:text-7xl lg:text-[7vw]">{content.title}</h1>
            <time dateTime={post.isoDate} className="mt-7 block text-[11px] uppercase tracking-eyebrow text-charcoal/55">{post.date[language]}</time>
          </Reveal>
        </header>
        <section className="px-6 pb-16 md:px-12 md:pb-24 lg:px-16">
          <Reveal>
            <div className="flex w-full items-center justify-center overflow-hidden bg-white p-3 sm:p-8">
              <img src={post.cover} alt={content.title} className="max-h-[82vh] h-auto w-auto max-w-full object-contain" loading="eager" decoding="async" />
            </div>
          </Reveal>
        </section>
        <section className="border-t border-charcoal px-6 py-16 md:px-12 md:py-24 lg:px-16 lg:py-28">
          <div className="grid grid-cols-12 gap-x-6 gap-y-10">
            <Reveal className="col-span-12 md:col-span-3"><span className="text-[11px] uppercase tracking-eyebrow text-charcoal/50">{post.type}</span></Reveal>
            <div className="col-span-12 md:col-span-7 md:col-start-5">
              {content.body.map((paragraph, index) => <Reveal key={index} delay={Math.min(index, 4) * 0.04}>
                <p className={`${index ? 'mt-7 text-lg text-charcoal/75 md:text-xl' : 'text-xl text-charcoal md:text-2xl'} whitespace-pre-line font-bold leading-relaxed`}>{paragraph}</p>
              </Reveal>)}
            </div>
          </div>
        </section>
      </article>
    </main>
    <Footer />
  </div>;
};

export default PostDetailPage;
